import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const project = useConnect('project.byId', {
    id: Number(match.params.projectId)
  });

  if (project.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      project={project}
      page="Demonstration"
      title="Right now, how do you expect your students will ultimately demonstrate their learning?"
      description={(
        <>
          What public products will your students create? Of course, this may become clearer or change
          over the course of your project. That's ok. What are you imagining right now?
        </>
      )}
    >
      <Form
        user={user}
        project={project}
        navigation={(
          <Navigation v5={true} activeStep={3} steps={19}/>
        )}
        onPrevious={(newData) => history.push(Urls(project).OUTCOME)}
        onNext={(newData) => history.push(Urls(project).SUMMARY)}
        onSkip={() => history.push(Urls(project).SUMMARY)}
        onExit={() => history.push(Urls(project).PROJECT_EDIT)}
      />
    </ParentLayout>
  );
};
